/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Hemoglobin List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './HemoglobinListView';

export const mapStateToPropsHemoglobinList = mapStateToProps;
export const mapDispatchToPropsHemoglobinList = mapDispatchToProps;

export default connect(
  mapStateToPropsHemoglobinList,
  mapDispatchToPropsHemoglobinList
)(View);
